<template>
  <div class="row mx-auto position-relative">
    <!-- <pre>{{ broadcastParamSt }}</pre> -->
    <div class="col-md-8 profile-info-left">
      <div class="card">
        <div class="card-body">
          <div class="col-md-12">
            <table class="table">
              <tbody>
                <tr>
                  <td class="text-muted text-left" style="width: 30%">Judul</td>
                  <th class="text-left">
                    <div class="d-flex justify-content-between">
                      <div class="">{{ broadcastParamSt.title }}</div>
                      <div class="">
                        <button
                          :disabled="
                            broadcastStep == '1' || broadcastStep == '2'
                          "
                          class="btn btn-primary"
                          v-if="broadcastStep !== '0'"
                          @click="broadcastStep = '0'"
                        >
                          Atur Judul
                        </button>
                        <template v-else>
                          <button
                            class="btn btn-danger"
                            v-if="broadcastParamSt.title !== ''"
                            @click="broadcastStep = ''"
                          >
                            Cancel
                          </button>
                        </template>
                      </div>
                    </div>
                  </th>
                </tr>
                <tr v-if="broadcastParamSt.ab_testing_enabled">
                  <td class="text-muted text-left">Variasi Pesan</td>
                  <th class="text-left">
                    {{ (broadcastParamSt.variants || []).length }} varian
                  </th>
                </tr>
                <tr v-show="broadcastStep === '0'">
                  <td colspan="2">
                    <form0 @update="previewPage" />
                  </td>
                </tr>
                <template v-if="broadcastParamSt.title !== ''">
                  <tr>
                    <td class="text-muted text-left">Nomor Pengirim</td>
                    <th v-if="multiSender" class="text-left">
                      <div class="d-flex justify-content-between w-full">
                        <div class="waajo-preview-sender-list">
                          <span
                            v-for="sender in selectedSenderOptions"
                            :key="sender.id"
                            class="waajo-preview-sender-chip"
                          >
                            <strong>{{ sender.license_name || "Nomor WhatsApp" }}</strong>
                            <small>{{ sender.license_phone_number }}</small>
                            <i
                              class="fa fa-circle"
                              :class="Number(sender.is_online_status) === 1 ? 'text-success' : 'text-danger'"
                            ></i>
                          </span>
                          <span v-if="!selectedSenderOptions.length" class="text-muted">
                            {{ selectedSenderIds.length }} nomor dipilih
                          </span>
                        </div>
                        <div class="">
                          <button
                            class="btn btn-primary"
                            type="button"
                            @click="$emit('edit-senders')"
                          >
                            Atur Pengirim
                          </button>
                        </div>
                      </div>
                    </th>
                    <th v-else class="text-left">
                      <div class="d-flex justify-content-between w-full">
                        <div class="">
                          <formSender v-model="editSender" />
                        </div>
                        <div class="">
                          <button
                            class="btn"
                            :class="editSender ? 'btn-danger' : 'btn-primary'"
                            type="button"
                            @click="editSender = !editSender"
                          >
                            {{ editSender ? "Batal" : "Atur Pengirim" }}
                          </button>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <tr>
                    <td class="text-muted text-left">Penerima</td>
                    <th class="text-left">
                      <div class="d-flex justify-content-between">
                        <div class="">
                          <template
                            v-if="
                              broadcastParamSt.is_group == 1 &&
                              broadcastParamSt.is_group_type == 'group'
                            "
                          >
                            <span
                              class="badge badge-info mr-1"
                              v-for="(row, idx) in broadcastParamSt.to_group"
                              :key="idx"
                            >
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#btnShowGroup"
                                class="text-white"
                                @click="selectedGroup(row)"
                                >{{ row.name }}</a
                              ></span
                            >
                          </template>
                          <template
                            v-else-if="
                              broadcastParamSt.is_group == 1 &&
                              broadcastParamSt.is_group_type == 'tags'
                            "
                          >
                            <span
                              class="badge badge-info mr-1"
                              v-for="(row, idx) in broadcastParamSt.to_group"
                              :key="idx"
                            >
                              <a
                                href="#"
                                data-toggle="modal"
                                data-target="#btnShowTags"
                                class="text-white"
                                @click="selectedTags(row)"
                                >{{ row.name }}</a
                              ></span
                            >
                          </template>
                          <template v-else>
                            <template v-for="(row, idx) in broadcastParamSt.to">
                              <span
                                class="badge badge-info mr-1"
                                :key="idx"
                                v-if="idx < 3"
                              >
                                {{ row.first_name }}
                                <i v-if="row.is_group == 0"
                                  >- {{ row.phone_number }}</i
                                >
                              </span>
                            </template>
                            <a-popover
                              v-if="broadcastParamSt.to.length > 3"
                              placement="bottom"
                            >
                              <template slot="content">
                                <div class="d-flex flex-column">
                                  <template
                                    v-for="(row, idx) in broadcastParamSt.to"
                                  >
                                    <small
                                      class="mb-1"
                                      :key="idx"
                                      v-if="idx > 2"
                                    >
                                      {{ row.first_name }}
                                      <i v-if="row.is_group == 0"
                                        >- {{ row.phone_number }}</i
                                      >
                                    </small>
                                  </template>
                                </div>
                              </template>
                              <template slot="title">
                                <span>More Recipients</span>
                              </template>
                              <span class="badge badge-info mr-1">
                                + {{ broadcastParamSt.to.length - 3 }} more
                              </span>
                            </a-popover>
                          </template>
                          <br />
                          <small>{{ totalRecipients }} Recipients</small>
                        </div>
                        <div class="">
                          <button
                            v-if="broadcastStep !== '1'"
                            :disabled="
                              broadcastStep == '0' || broadcastStep == '2'
                            "
                            class="btn btn-primary"
                            @click="broadcastStep = '1'"
                          >
                            Atur Penerima
                          </button>
                        </div>
                      </div>
                    </th>
                  </tr>
                  <tr v-show="broadcastStep === '1'">
                    <td colspan="2">
                      <form1 @update="previewPage" />
                    </td>
                  </tr>
                  <tr>
                    <td class="text-muted text-left">Pesan</td>
                    <td class="text-muted text-left">
                      <div class="d-flex justify-content-between">
                        <span> Jenis Pesan:  <br>
                          <i
                            class="badge badge-primary"
                            v-if="
                              broadcastParamSt.message.message_type == 'text'
                            "
                            >Text Only</i
                          >
                          <i class="badge badge-primary" v-else>Media</i></span
                        >
                        <div class="">
                          <button
                            :disabled="
                              broadcastParamSt.title == '' &&
                              broadcastParamSt.license_id == '' &&
                              checkRecipient()
                            "
                            class="btn btn-primary"
                            @click="broadcastStep = '2'"
                          >
                            Atur Pesan
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr class="waajo-preview-message-row">
                    <td colspan="2">
                      <div
                        class="card"
                        v-if="hasPreviewContent"
                      >
                        <div
                          class="card-body"
                          id="preview"
                          :style="
                            'background: url(\'' + whatsappBackground + '\');'
                          "
                        >
                          <preview-message
                            v-model="broadcastParamSt"
                            :textReplyRows="textReplyRows"
                            :buttonsRows="buttonsRows"
                            :linkRows="linkRows"
                            :formatter="previewFormatter"
                            :show-variants="true"
                          />
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <!-- <div class="col-md-12" v-if="isCompleteForm">
            <button class="btn btn-primary" @click="onComplete(0)">
              Draft
            </button>
          </div> -->
        </div>
      </div>
    </div>
    <div v-if="isCompleteForm" class="col-md-4"> 
      <div  class="position-sticky" style="top: 5rem" >
        <div
          class="col text-right profile-info-top pb-3 mb-3"
          style="border-bottom: 2px dashed #ccc"
          v-if="isCompleteForm && broadcastStep == '' "
        >
          <button
            class="btn btn-primary" :disabled="isEditSchedule"
            @click="onComplete(0)"
          >
            <i class="fa fa-save"></i>
            Draft Broadcast
          </button>
          <button
            class="btn btn-success" :disabled="isEditSchedule"
            @click="onComplete(1)"
          >
            <i class="fa fa-send"></i>
            Send Broadcast
          </button>
        </div>
        <scheduler @updateEdit="updateEditSchedule"/>

      </div>
    </div>
    <div class="col-md-4" v-else>
      <div class="alert alert-warning" v-if="!isCompleteForm">
        <strong>Peringatan!</strong> Mohon lengkapi data sebelum mengirim broadcast.
        <ul>
          <li v-if="!broadcastParamSt.title">Judul belum diisi</li>
          <li v-if="!selectedSenderIds.length">Nomor Pengirim belum diisi</li>
          <li v-if="broadcastParamSt.is_group && !broadcastParamSt.to_group.length">Penerima belum diisi</li>
          <li
            v-if="
              broadcastParamSt.ab_testing_enabled &&
              (broadcastParamSt.message.message_type || 'text') === 'text' &&
              !broadcastParamSt.message.text
            "
          >
            Pesan Content A belum diisi
          </li>
          <li
            v-else-if="
              !broadcastParamSt.ab_testing_enabled &&
              !broadcastParamSt.message.text
            "
          >
            Pesan belum diisi
          </li>
          <li
            v-if="
              broadcastParamSt.ab_testing_enabled &&
              (broadcastParamSt.message.message_type || 'text') !== 'text' &&
              !broadcastParamSt.message.file_url
            "
          >
            Media Content A belum diisi
          </li>
        </ul>
      </div>

    </div>

    <preview-group ref="modalPreviewGroup" />
    <preview-tags ref="modalPreviewTags" />
  </div>
</template>

<script>
import formSender from "./formSender.vue";
import PreviewMessage from "./preview";
import PreviewGroup from "./previewGroup";
import PreviewTags from "./previewTags";
import form0 from "./form0.vue";
import form1 from "./form1.vue";
import scheduler from "./scheduler.vue";
import {
  normalizeLicenseIds,
  selectedSenderOptions as pickSenderOptions,
} from "@/utils/broadcastMonitor";
export default {
  components: {
    formSender,
    PreviewMessage,
    PreviewGroup,
    PreviewTags,
    form0,
    form1,
    scheduler,
  },
  props: {
    previewFormatter: {
      type: Function,
      default: null,
    },
    senderOptions: {
      type: Array,
      default: function() {
        return [];
      },
    },
    multiSender: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasPreviewContent() {
      const form = this.broadcastParamSt || {};
      const message = form.message || {};

      if (message.text || message.file_url) {
        return true;
      }

      if (!form.ab_testing_enabled) {
        return false;
      }

      return (form.variants || []).some((variant) => {
        const variantMessage = (variant && variant.message) || {};
        return !!(variantMessage.text || variantMessage.file_url);
      });
    },
    totalRecipients() {
      if (this.broadcastParamSt.is_group) {
        let qty = this.broadcastParamSt.to_group.map((i) => {
          return i.name.split(" ~ ")[1];
        });
        return qty.reduce((a, b) => Number(a) + Number(b), 0);
      } else {
        return this.broadcastParamSt.to.length;
      }
    },
    selectedSenderIds() {
      return normalizeLicenseIds(
        this.broadcastParamSt.license_ids,
        this.broadcastParamSt.license_id
      );
    },
    selectedSenderOptions() {
      return pickSenderOptions(this.senderOptions, this.selectedSenderIds);
    },
    isCompleteForm() {
      const { title, is_group, to_group, to, message } = this.broadcastParamSt;
      if (!title) return false;
      if (!this.selectedSenderIds.length) return false;
      if (is_group) {
        if (!to_group.length) return false;
      } else {
        if (!to.length) return false;
      }

      if (this.broadcastParamSt.ab_testing_enabled) {
        if (
          !this.broadcastParamSt.variants ||
          this.broadcastParamSt.variants.length === 0
        ) {
          return false;
        }

        const messageType = message.message_type || "text";
        if (messageType === "text") {
          if (!message.text) return false;
        } else if (!message.file_url) {
          return false;
        }
      } else if (!message.text) {
        return false;
      }

      return true;
    },
    broadcastParamSt: {
      get() {
        return this.$store.state.omniwa.broadcastParamSt;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastParamSt", val);
      },
    },
    broadcastStep: {
      get() {
        return this.$store.state.omniwa.broadcastStep;
      },
      set(val) {
        this.$store.commit("omniwa/SET_broadcastStep", val);
      },
    },
  },
  data() {
    return {
      selectedLicense: [],
      licenseOptions: [],
      whatsappBackground: process.env.VUE_APP_WHATSAPP_BACKGROUND,
      isLoadingLicense: false,
      editSender: false,
      isEditSchedule:false,
      textReplyRows: [],
      buttonsRows: [],
      linkRows: [],
      broadcastParam: {},
    };
  },
  methods: { 
    updateEditSchedule(val){
      this.isEditSchedule = val
    },
    check(){
      console.log(this.$refs.scheduler)
    },
    buildVariantsPayload() {
      const variants = this.broadcastParam.variants || [];
      const deletedCodes = this.broadcastParam.pending_deleted_variant_codes || [];
      const payload = [];

      variants.forEach((variant, index) => {
        if (!variant || variant.deleted) return;

        const message = variant.message || {};
        const messageType = message.message_type || "text";
        const isInteractive = !!variant.interactive_message_status;
        let text = message.text || "";

        if (messageType === "text") {
          text = this.remove_tags(text);
        }

        payload.push({
          variant_code: variant.variant_code,
          variant_order: Number(variant.variant_order) || index + 1,
          message: {
            text: text,
            message_type: messageType,
            file_url: message.file_url || "",
          },
          is_custom_url: !!variant.is_custom_url,
          interactive_message_status: isInteractive,
          interactive_message_type: isInteractive
            ? variant.interactive_message_type || "text_reply"
            : "",
          buttons: isInteractive
            ? (variant.buttons || [])
                .filter((button) => button && button.id)
                .map((button) => ({ id: button.id }))
            : [],
          footer_message_status: !!variant.footer_message_status,
          footer_message: variant.footer_message || "",
          list_button_text: variant.list_button_text || "Options",
        });
      });

      deletedCodes.forEach((code) => {
        if (!code) return;
        const exists = payload.some(
          (variant) =>
            String(variant.variant_code).toUpperCase() ===
            String(code).toUpperCase()
        );
        if (!exists) {
          payload.push({ variant_code: code, deleted: true });
        }
      });

      return payload;
    },
    async onComplete(isPublish) {
      this.isLoadingBc = await true;
      this.broadcastParam = structuredClone(this.broadcastParamSt);
      const senderIds = normalizeLicenseIds(
        this.broadcastParam.license_ids,
        this.broadcastParam.license_id
      );
      this.broadcastParam.license_ids = senderIds;
      this.broadcastParam.license_id = senderIds.length ? senderIds[0] : "";
      let copy = this.$route.query.copy;
      if (typeof copy != "undefined" && copy == "1") {
        this.broadcastParam.broadcast_id = "";
      }
      await this.bcMessageHandler(isPublish);
    },
    async buildDestinationFromGroup() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0,
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        // console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      let arrCon = {
        id: "",
        phone_number: 62,
        is_group: 1,
        phone_number_group: "",
      };
      this.broadcastParam.to.push(arrCon);
      // await this.$store
      //   .dispatch("contact/getContactList", this.contactListParam)
      //   .then(response => {
      //     let { data } = response;
      //     data.forEach((rowCon, ind) => {
      //       let arrCon = {
      //         id: rowCon.id,
      //         phone_number: rowCon.phone_number,
      //         is_group: rowCon.is_group,
      //         phone_number_group: rowCon.phone_number_group
      //       };
      //       this.broadcastParam.to.push(arrCon);
      //     });
      //   });
    },
    async buildDestinationFromTags() {
      this.broadcastParam.to = await [];
      this.contactListParam = await {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        page: 0,
        perPage: 100000,
        rendered: 0,
        totalRecords: 0,
      };
      await this.broadcastParam.to_group.forEach((row, index) => {
        // console.log("rowGroup", row);
        this.contactListParam.group_id.push(row.id);
      });
      let arrCon = {
        id: "",
        phone_number: 62,
        is_group: 1,
        phone_number_group: "",
      };
      this.broadcastParam.to.push(arrCon);
      // await this.$store
      //   .dispatch("contact/getContactListFromTags", this.contactListParam)
      //   .then(response => {
      //     let { data } = response;
      //     data.forEach((rowCon, ind) => {
      //       let arrCon = {
      //         id: rowCon.id,
      //         phone_number: rowCon.phone_number,
      //         is_group: rowCon.is_group,
      //         phone_number_group: rowCon.phone_number_group
      //       };
      //       this.broadcastParam.to.push(arrCon);
      //     });
      //   });
    },
    previewPage() {},
    async bcMessageHandler(isSend = 0, updateOnly = 0) {
      this.broadcastParam.to_test = [];

      if (isSend == 0) {
        this.broadcastParam.is_send = 0;
      } else {
        this.broadcastParam.is_send = 1;
      }
      if (this.broadcastParam.is_group == 1) {
        if (this.broadcastParam.to_group.length == 0) {
          this.isLoadingBc = await false;

          //error no destination
          // error
          this.$fire({
            title: "Error",
            text: "Destination is required!",
            type: "error",
            timer: 2000,
          }).then((r) => {});
          return;
        }
        if (this.broadcastParam.is_group_type == "tags") {
          await this.buildDestinationFromTags();
        } else {
          await this.buildDestinationFromGroup();
        }
      }

      //validasi data
      if (
        this.broadcastParam.to.length == 0 &&
        this.broadcastParam.to_group.length == 0
      ) {
        //error no destination
        // error
        this.$fire({
          title: "Error",
          text: "Destination is required!",
          type: "error",
          timer: 2000,
        }).then((r) => {});
        return;
      }
      if (
        this.broadcastParam.message.message_type != "text" &&
        this.broadcastParam.message.file_url == ""
      ) {
        this.isLoadingBc = await false;

        //error no media
        this.$fire({
          title: "Error",
          text:
            "File is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000,
        }).then((r) => {});
        return;
      }

      if (
        this.broadcastParam.message.message_type == "text" &&
        this.broadcastParam.message.text.trim() == ""
      ) {
        this.isLoadingBc = await false;

        //error no text for type text
        this.$fire({
          title: "Error",
          text:
            "Text is required for " +
            this.broadcastParam.message.message_type +
            " message!",
          type: "error",
          timer: 2000,
        }).then((r) => {});
        return;
      }

      // return;

      // console.log("aaaaa", this.broadcastParamSt)

      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`,
      }).then(async (r) => {
        if (r.value == true) {
          if (updateOnly == 1) {
            //maka hanya update data
            this.broadcastParam.update_only = true;
          } else {
            this.broadcastParam.update_only = false;
          }

          this.isSending = await true;
          // this.emojiToggle(false);
          this.broadcastParam.message.text = await this.remove_tags(
            this.broadcastParam.message.text
          );

          this.broadcastParam.is_recurring = this.broadcastParamSt.is_recurring;
          this.broadcastParam.recurring_form =
            this.broadcastParamSt.recurring_form;

          let newButtons = [];
          if (
            this.broadcastParam.interactive_message_status == true &&
            Array.isArray(this.broadcastParam.buttons)
          ) {
            this.broadcastParam.buttons.forEach((button) => {
              const id =
                button && typeof button === "object" ? button.id : button;
              if (id != "" && id != null) {
                newButtons.push(button);
              }
            });
          }

          this.broadcastParam.buttons = newButtons;
          // console.log("newButtons", newButtons);

          // Sertakan variants hanya jika Variasi Pesan aktif atau ada varian yang dihapus.
          const allVariantsPayload = this.buildVariantsPayload();
          const activeVariantsPayload = this.broadcastParam.ab_testing_enabled
            ? allVariantsPayload.filter((variant) => !variant.deleted)
            : [];
          const deletedVariantsPayload = allVariantsPayload.filter(
            (variant) => variant.deleted
          );
          const finalVariantsPayload = activeVariantsPayload.concat(
            deletedVariantsPayload
          );

          if (finalVariantsPayload.length > 0) {
            this.broadcastParam.variants = finalVariantsPayload;
          } else {
            delete this.broadcastParam.variants;
          }
          delete this.broadcastParam.ab_testing_enabled;
          delete this.broadcastParam.pending_deleted_variant_codes;
          delete this.broadcastParam.pending_deleted_variant_orders;

          await this.$store
            .dispatch("omniwa/sendBroadcast", this.broadcastParam)
            .then((response) => {
              this.isLoadingBc = false;

              this.files = [];
              this.selectedLicense = [];
              this.selectedContactGroup = [];
              this.selectedContact = [];
              // this.isSending = false;
              if (this.broadcastParam.broadcast_id == "") {
                this.broadcastParam = {
                  //from state
                  form_speed: {
                    delay_interval: { wait_min: 0, wait_max: 0 },
                    rest_mode: { stop_after: 0, rest_for: 0 },
                  },
                  speed_mode: "normal",
                  speed_wait_min: 0,
                  speed_wait_max: 0,
                  speed_stop_after: 0,
                  speed_rest_for: 0,
                  title: "",
                  provider: "whatsapp",
                  to_group: [],
                  to: [],
                  is_group: this.broadcastParam.is_group, //for group set 1, for personal set 0
                  is_group_type: this.broadcastParam.is_group_type, //group/tags
                  license_id: "",
                  license_ids: [],
                  message: {
                    text: "",
                    message_type: this.broadcastParam.message.message_type, //text,image,document
                    file_url: "",
                  },
                  sending_options: 1,
                  sending_schedule: "",
                  is_recurring: 0,
                  recurring_form: {
                    recurrence: "",
                    recurrence_every: "",
                    recurrence_annually_month: "",
                    recurrence_end: "never",
                    recurrence_end_date: "",
                  },
                  is_send: 1,
                  to_test: [],
                  interactive_message_status: false,
                  interactive_message_type: "button_text",
                  buttons: [
                    { id: "" },
                    { id: "" },
                    { id: "" },
                    { id: "" },
                    { id: "" },
                    { id: "" },
                    { id: "" },
                    { id: "" },
                    { id: "" },
                    { id: "" },
                  ],
                  ab_testing_enabled: false,
                  variants: [],
                  pending_deleted_variant_codes: [],
                  pending_deleted_variant_orders: [],
                  list_button_text: "Options",
                };
              }

              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000,
              }).then((r) => {
                this.$router.push({
                  path: `/message_report/broadcast/info?id=` + response.data.id,
                });
              });
              this.searchData();
              var elem = this.$refs.dismisModal;
              elem.click();
              this.isSending = false;
            })
            .catch(() => {
              this.isSending = false;
              this.isLoadingBc = false;
            });
        } else {
          this.isLoadingBc = false;
          this.isSending = false;
        }
      });
    },
    // async onComplete(isPublish) {
    //   this.isLoadingBc = await true;
    //   await this.bcMessageHandler(isPublish);
    // },
    // async bcMessageHandler(isSend = 0, updateOnly = 0) {
    //   this.broadcastParamSt.to_test = [];

    //   // if (isSend == 0) {
    //   //   this.broadcastParamSt.is_send = 0;
    //   // } else {
    //   //   this.broadcastParamSt.is_send = 1;
    //   // }
    //   if (this.broadcastParamSt.is_group == 1) {
    //     if (this.broadcastParamSt.to_group.length == 0) {
    //       this.isLoadingBc = await false;

    //       //error no destination
    //       // error
    //       this.$fire({
    //         title: "Error",
    //         text: "Destination is required!",
    //         type: "error",
    //         timer: 2000,
    //       }).then((r) => {});
    //       return;
    //     }
    //     // if (this.broadcastParamSt.is_group_type == "tags") {
    //     //   await this.buildDestinationFromTags();
    //     // } else {
    //     //   await this.buildDestinationFromGroup();
    //     // }
    //   }

    //   //validasi data
    //   if (
    //     this.broadcastParamSt.to.length == 0 &&
    //     this.broadcastParamSt.to_group.length == 0
    //   ) {
    //     //error no destination
    //     // error
    //     this.$fire({
    //       title: "Error",
    //       text: "Destination is required!",
    //       type: "error",
    //       timer: 2000,
    //     }).then((r) => {});
    //     return;
    //   }
    //   if (
    //     this.broadcastParamSt.message.message_type != "text" &&
    //     this.broadcastParamSt.message.file_url == ""
    //   ) {
    //     this.isLoadingBc = await false;

    //     //error no media
    //     this.$fire({
    //       title: "Error",
    //       text:
    //         "File is required for " +
    //         this.broadcastParamSt.message.message_type +
    //         " message!",
    //       type: "error",
    //       timer: 2000,
    //     }).then((r) => {});
    //     return;
    //   }

    //   if (
    //     this.broadcastParamSt.message.message_type == "text" &&
    //     this.broadcastParamSt.message.text.trim() == ""
    //   ) {
    //     this.isLoadingBc = await false;

    //     //error no text for type text
    //     this.$fire({
    //       title: "Error",
    //       text:
    //         "Text is required for " +
    //         this.broadcastParamSt.message.message_type +
    //         " message!",
    //       type: "error",
    //       timer: 2000,
    //     }).then((r) => {});
    //     return;
    //   }
    //   let form_data = {
    //       //from state
    //       form_speed: {
    //         delay_interval: {
    //           wait_min:
    //             this.broadcastParamSt.form_speed.delay_interval.wait_min,
    //           wait_max:
    //             this.broadcastParamSt.form_speed.delay_interval.wait_max,
    //         },
    //         rest_mode: {
    //           stop_after: this.broadcastParamSt.form_speed.rest_mode.stop_after,
    //           rest_for: this.broadcastParamSt.form_speed.rest_mode.rest_for,
    //         },
    //       },
    //       error_import: 0,
    //       success_import: 0,
    //       is_import: 0,
    //       speed_mode: this.broadcastParamSt.form_speed.speed_mode,
    //       speed_wait_min: this.broadcastParamSt.form_speed.speed_wait_min,
    //       speed_wait_max: this.broadcastParamSt.form_speed.speed_wait_max,
    //       speed_stop_after: this.broadcastParamSt.form_speed.speed_stop_after,
    //       speed_rest_for: this.broadcastParamSt.form_speed.speed_rest_for,
    //       is_custom_url: this.broadcastParamSt.is_custom_url,
    //       // rowDetail: {},
    //       is_duplicate: this.broadcastParamSt.is_duplicate,
    //       broadcast_id: "",
    //       title: this.broadcastParamSt.title,
    //       provider: this.broadcastParamSt.provider,
    //       license_id: this.broadcastParamSt.license_id,
    //       to_group:
    //         this.broadcastParamSt.is_group == "1"
    //           ? this.broadcastParamSt.to_group.map((i) => {
    //               return {
    //                 id: i.id,
    //                 phone_number: 0,
    //                 name: i.name,
    //                 first_name: i.name,
    //                 phone_number_group: "",
    //                 is_group: 1,
    //               };
    //             })
    //           : [],
    //       to:
    //         this.broadcastParamSt.is_group == "1"
    //           ? [
    //               {
    //                 id: "",
    //                 phone_number: 62,
    //                 is_group: 1,
    //                 phone_number_group: "",
    //               },
    //             ]
    //           : this.broadcastParamSt.to,
    //       is_group: this.broadcastParamSt.is_group, //for group set 1, for personal set 0
    //       is_group_type: this.broadcastParamSt.is_group_type, //group/tags
    //       message: {
    //         text: this.remove_tags(this.broadcastParamSt.message.text),
    //         message_type: this.broadcastParamSt.message.message_type, //text,image,document
    //         file_url: this.broadcastParamSt.message.file_url,
    //       },
    //       sending_options: this.broadcastParamSt.sending_options,
    //       sending_schedule: this.broadcastParamSt.sending_schedule,
    //       is_recurring: this.broadcastParamSt.is_recurring,
    //       recurring_form: this.broadcastParamSt.recurring_form,
    //       is_send: isSend,
    //       to_test: "",
    //       is_custom_url: this.broadcastParamSt.is_custom_url,
    //       interactive_message_status:
    //         this.broadcastParamSt.interactive_message_status,
    //       interactive_message_type:
    //         this.broadcastParamSt.interactive_message_type,
    //       footer_message_status: this.broadcastParamSt.footer_message_status,
    //       footer_message: this.broadcastParamSt.footer_message,
    //       buttons: !this.broadcastParamSt.interactive_message_status
    //         ? []
    //         : this.broadcastParamSt.buttons
    //             .filter((i) => i.id != "")
    //             .map((btnId, idx) => {
    //               return btnId;
    //             }),
    //       update_only: updateOnly == 1,
    //     };
    //     console.log(form_data)
    //   this.$fire({
    //     title: "Are you sure you will continue this action?",
    //     showDenyButton: true,
    //     showCancelButton: true,
    //     confirmButtonText: `Yes`,
    //     denyButtonText: `Cancel`,
    //   }).then(async (r) => {

    //     if (r.value == true) {
    //       // if (updateOnly == 1) {
    //       //   //maka hanya update data
    //       //   this.broadcastParamSt.update_only = true;
    //       // } else {
    //       //   this.broadcastParamSt.update_only = false;
    //       // }

    //       this.isSending = await true;
    //       // this.emojiToggle(false);
    //       // this.broadcastParamSt.message.text = await

    //       // this.broadcastParamSt.is_recurring =
    //       //   this.broadcastParamSt.is_recurring;
    //       // this.broadcastParamSt.recurring_form =
    //       //   this.broadcastParamSt.recurring_form;

    //       // let newButtons = [];
    //       // // console.log("this.broadcastParamSt.buttons",this.broadcastParamSt.buttons)
    //       // if (this.broadcastParamSt.interactive_message_status == true) {
    //       //   // newButtons = this.broadcastParamSt.buttons;
    //       //   if (this.broadcastParamSt.buttons.length) {
    //       //     this.broadcastParamSt.buttons.forEach((btnId, idx) => {
    //       //       if (btnId != "") {
    //       //         newButtons.push(btnId);
    //       //       }
    //       //     });
    //       //   }
    //       // }

    //       // this.broadcastParamSt.buttons = newButtons;
    //       // console.log("newButtons", newButtons);
    //       await this.$store
    //         .dispatch("omniwa/sendBroadcast", this.broadcastParamSt)
    //         .then((response) => {
    //           this.isLoadingBc = false;

    //           this.files = [];
    //           this.selectedLicense = [];
    //           this.selectedContactGroup = [];
    //           this.selectedContact = [];
    //           // this.isSending = false;
    //           if (this.broadcastParamSt.broadcast_id == "") {
    //             this.broadcastParamSt = {
    //               //from state
    //               form_speed: {
    //                 delay_interval: { wait_min: 0, wait_max: 0 },
    //                 rest_mode: { stop_after: 0, rest_for: 0 },
    //               },
    //               speed_mode: "normal",
    //               speed_wait_min: 0,
    //               speed_wait_max: 0,
    //               speed_stop_after: 0,
    //               speed_rest_for: 0,
    //               title: "",
    //               provider: "whatsapp",
    //               to_group: [],
    //               to: [],
    //               is_group: this.broadcastParamSt.is_group, //for group set 1, for personal set 0
    //               is_group_type: this.broadcastParamSt.is_group_type, //group/tags
    //               license_id: "",
    //               message: {
    //                 text: "",
    //                 message_type: this.broadcastParamSt.message.message_type, //text,image,document
    //                 file_url: "",
    //               },
    //               sending_options: 1,
    //               sending_schedule: "",
    //               is_recurring: 0,
    //               recurring_form: {
    //                 recurrence: "",
    //                 recurrence_every: "",
    //                 recurrence_annually_month: "",
    //                 recurrence_end: "never",
    //                 recurrence_end_date: "",
    //               },
    //               is_send: 1,
    //               to_test: [],
    //               interactive_message_status: false,
    //               interactive_message_type: "button_text",
    //               buttons: [
    //                 { id: "" },
    //                 { id: "" },
    //                 { id: "" },
    //                 { id: "" },
    //                 { id: "" },
    //                 { id: "" },
    //                 { id: "" },
    //                 { id: "" },
    //                 { id: "" },
    //                 { id: "" },
    //               ],
    //             };
    //           }

    //           this.$fire({
    //             title: "Success",
    //             text: response["msg"],
    //             type: "success",
    //             timer: 2000,
    //           }).then((r) => {
    //             this.$router.push({
    //               path: `/message_report/broadcast/info?id=` + response.data.id,
    //             });
    //           });
    //           this.searchData();
    //           var elem = this.$refs.dismisModal;
    //           elem.click();
    //           this.isSending = false;
    //         })
    //         .catch(() => {
    //           this.isSending = false;
    //           this.isLoadingBc = false;
    //         });
    //     } else {
    //       this.isLoadingBc = false;
    //       this.isSending = false;
    //     }
    //   });
    // },
    remove_tags(html) {
      var html = html.replace("<br />", "||br||");
      var tmp = document.createElement("DIV");
      tmp.innerHTML = html;
      html = tmp.textContent || tmp.innerText;
      return html.replace("||br||", "<br />");
    },
    checkRecipient() {
      console.log(this.broadcastParamSt.is_group);
      if (this.broadcastParamSt.is_group == 1) {
        return this.broadcastParamSt.to_group.length > 0;
      } else {
        return this.broadcastParamSt.to.length > 0;
      }
    },
    selectedTags(row) {
      this.$refs.modalPreviewTags.getGroupSelected(row);
    },
    selectedGroup(row) {
      this.$refs.modalPreviewGroup.getGroupSelected(row);
    },

    async loadTextReply() {
      this.buttonsLoading = await true;
      this.textReplyParams.page = 0;
      await this.$store
        .dispatch("automation/listTextReply", this.textReplyParams) // sesuai kan dengan method di API
        .then((response) => {
          const { data } = response;
          this.textReplyRows = data.data;
          this.buttonsLoading = false;
        })
        .catch((error) => {
          this.buttonsLoading = false;
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
.waajo-preview-sender-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.waajo-preview-sender-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 8px;
  border-radius: 999px;
  background: #fff4e6;
  border: 1px solid #ffe0b8;
  color: #93370d;
  font-size: 11px;
}
.waajo-preview-sender-chip strong {
  font-size: 11px;
  color: #7a2e0e;
}
.waajo-preview-sender-chip small {
  color: #b54708;
  font-size: 10px;
}
.waajo-preview-sender-chip i {
  font-size: 6px;
}
</style>
 


// WEBPACK FOOTER //
// src/views/broadcast/componentsV2/Forms/formPreview.vue